// @ts-nocheck

import { reduce as _reduce } from 'lodash';

import basketActions from '../actions/basket';
import { selectIsGREnabledAndNotForbidden } from '../modules/gift-race/selectors/specifics/selectGRRuntime';
import { getActivePools } from '../modules/grids/selectors/pool';
import { default as GridBasket } from '../modules/grids/states/basket';
import { GridsActionTypes } from '../modules/grids/types/actions';
import { StorageActionTypes } from '../types/actions/common';
import { RuntimeActionTypes } from '../types/actions/runtime';
import { basket as BasketUtils } from '../utils';

const storageMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case RuntimeActionTypes.SET_LICENCE: {
      const { getState, dispatch } = store;
      const { runtime } = getState();
      const { licence: previousLicence } = runtime;
      const { licence: newLicence } = action.payload;
      if (newLicence !== previousLicence) {
        // if basket licence on localStorage does not fit actual licence, we clear basket (and basket storage)
        dispatch(basketActions.basketClear());
      }
      break;
    }
    case StorageActionTypes.BASKET_SAVE: {
      const state = store.getState();
      const { basket } = state;
      const {
        items,
        mode,
        systems,
        defaultStake,
        stake,
        isCashout,
        cashoutBetslipType,
        cashoutBetslipId,
        isFromFreebets,
        isGRActive,
        isFromLineUp,
        isMonopolyActive,
        monopolyCard,
        cachedMMAPIResponsesInfos,
        isBoomActive,
        boom,
      } = basket;
      const finalBasketItems = _reduce(
        items,
        (basketItems, item) => {
          const {
            oddId,
            matchId,
            betId,
            value,
            banker,
            sportId,
            stake: itemStake,
            sortBy,
            cashout,
            betbuilder,
            selectionItems,
            isFromLineUp: isItemFromLineUp,
            isGRActive: isItemGRActive,
            isMonopolyActive: isItemMonopolyActive,
            monopolyCard: itemMonopolyCard,
            isBoomActive: isItemBoomActive,
            boom: itemBoom,
          } = item;

          const nextItem = {
            oddId,
            matchId,
            betId,
            value,
            banker,
            sportId,
            stake: itemStake,
            cashout,
            sortBy,
            betbuilder,
            selectionItems,
            isGRActive: isItemGRActive,
            isMonopolyActive: isItemMonopolyActive,
            monopolyCard: itemMonopolyCard,
            isFromLineUp: isItemFromLineUp,
            isBoomActive: isItemBoomActive,
            boom: itemBoom,
          };

          const isGREnabled = selectIsGREnabledAndNotForbidden(state);

          if (!isGREnabled) {
            delete nextItem.isGRActive;
          }

          return {
            ...basketItems,
            [oddId]: nextItem,
          };
        },
        {},
      );

      BasketUtils.saveBasketToStorage({
        items: finalBasketItems,
        mode,
        systems,
        defaultStake,
        stake,
        isCashout,
        cashoutBetslipType,
        cashoutBetslipId,
        isFromFreebets,
        isGRActive,
        isMonopolyActive,
        monopolyCard,
        isFromLineUp,
        cachedMMAPIResponsesInfos,
        isBoomActive,
        boom,
      });
      break;
    }
    default:
      break;
  }
  const returnValue = next(action);
  switch (action.type) {
    case GridsActionTypes.CHECK:
    case GridsActionTypes.FILL_RANDOMLY:
    case GridsActionTypes.CLEAR_CHECKS:
    case GridsActionTypes.TOGGLE_PRIVATE_MODE:
    case GridsActionTypes.TOGGLE_SYSTEM_MODE:
    case GridsActionTypes.SWITCH_TYPE:
    case GridsActionTypes.SET_SYSTEM_GRID_INDEX:
    case GridsActionTypes.COPY_SYSTEM_GRID:
    case GridsActionTypes.ADD_SYSTEM_GRID:
    case GridsActionTypes.TOGGLE_SYSTEM_MODE_GRID:
    case GridsActionTypes.REMOVE_SYSTEM_GRID:
    case GridsActionTypes.UPDATE_BASKET: {
      const { getState } = store;
      const { basket } = getState().grids;
      const pools = getActivePools(getState());
      if (basket.poolId) {
        GridBasket.saveToStorage(basket, pools);
      }
      break;
    }
    default:
      break;
  }
  return returnValue;
};

export default storageMiddleware;
